jQuery(function () {
  jQuery("[js-coursemenu]").each(function () {
    var el = $(this);
    var toggleMenuBreakPoint = 768;

    /*if (luvit.IsTouchDevice()) {
        $(".course.menu, body").swipe({

            swipeLeft: function (event, direction, distance, duration, fingerCount) {
                debugger
                eduutils.ToggleCourseMenu()
            },excludedElements:""
        });
    }*/

    if (luvit.IsTouchDevice()) {
      setTimeout(
        () =>
          $(".course.menu").swipe({
            swipeLeft: (event, direction, distance, duration, fingerCount) => {
              eduutils.ToggleCourseMenu();
            },
            excludedElements: "select,input,textarea,label",
          }),
        50,
      );
    }

    if (luvit.IsIPad()) {
      $("#divToolbarBottom").css("display", "none");
      /* document.getElementById("divMenuContainer").addEventListener('touchstart', function (e) {
           $('.toolbar-bottom').addClass('hidden');
       });

        document.getElementById("divMenuContainer").addEventListener('touchmove', function (e) {
            $('.toolbar-bottom').addClass('hidden');
        });

        document.getElementById("divMenuContainer").addEventListener('touchend', function (e) {
            //alert("touch end");
           $('.toolbar-bottom').removeClass('hidden');
       });

       document.getElementById("divMenuContainer").addEventListener('touchcancel', function (e) {
           $('.toolbar-bottom').removeClass('hidden');
       });*/
    }
    $(".content-edu").swipe({
      swipeRight: function (event, direction, distance, duration, fingerCount) {
        eduutils.ToggleCourseMenu();
      },
    });

    $("body").keyup(function (e) {
      if (!(e.ctrlKey && e.shiftKey)) return;
      if (e.keyCode == 13) {
        eduutils.ToggleCourseMenu();
      }
    });

    //Open menu when clicking on portal icon or course image
    $(".icon-portal, .menu-image").click(function (event) {
      if (!$(".menu").hasClass("selected")) {
        eduutils.ToggleCourseMenu();
      }
      if (event && event.stopPropagation) {
        event.stopPropagation();
      } else if (window.event) {
        window.event.cancelBubble = true;
      }
    });

    $(".menu-column li").click(function (event) {
      event.stopPropagation();

      //If menu is closed
      if (
        !$(".menu").hasClass("selected") &&
        !$(event.target).hasClass("menu-icon")
      ) {
        eduutils.ToggleCourseMenu();
      } else {
        if (!$(event.target).closest("li").hasClass("noselect")) {
          //Close menu if in mobile
          if (
            $("[id*='mobilefooter']").is(":visible") ||
            $(window).width() < eduutils.toggleMenuBreakPoint
          ) {
            eduutils.ToggleCourseMenu();
          }
        }
      }

      //Do not set my courses or menus with sub menus as active
      if ($(this).hasClass("noselect")) {
        return;
      }

      $(".menu-column .menu-functionmenu li.active").removeClass("active");

      //no active nodes in tree, but keep state
      luvitedu.resetTree(true);
      $(this).addClass("active");
      let activeMenu = $(event.target).closest("li").data("id");
      eduutils.SetActiveCourseMenuItem(activeMenu);
    });

    $(".coursematerial .icon-coursecontent").click(function (event) {
      if (!$(".menu").hasClass("selected")) {
        eduutils.ToggleCourseMenu();
        $(".menu-column").scrollTo($(".coursematerial"));
        if (event && event.stopPropagation) {
          event.stopPropagation();
        } else if (window.event) {
          window.event.cancelBubble = true;
        }
      }
    });

    $("#ToggleIcon").click(function (event) {
      eduutils.ToggleCourseMenu();
    });

    $(".footercoursemenutoggle").click(function (evt) {
      eduutils.ToggleCourseMenu();
      $(".menu-column").scrollTo(0);
    });

    $("#OpenCourseMaterial").click(function () {
      eduutils.ToggleCourseMenu();
      $(".menu-column").scrollTo($(".navtree-controls"));
    });

    $(".course.menu").bind("stateChanged", function () {
      var state = {};

      if (luvit.getItem("luvit_coursemenustate")) {
        state = $.parseJSON(luvit.getItem("luvit_coursemenustate"));

        if ($(".course.menu").hasClass("selected")) {
          state.main = "open";
        } else {
          state.main = "closed";
        }
      } else {
        if ($(".course.menu").hasClass("selected")) state = { main: "open" };
        else state = { main: "open" };
      }

      luvit.setItem("luvit_coursemenustate", JSON.stringify(state));
    });

    function toggleMenuAuto(state) {
      if (state == "close") {
        if ($(".menu").hasClass("selected")) {
          eduutils.CloseCourseSubMenus();
          $(".menu").toggleClass("selected");
          $(".menu").trigger("stateChanged");
          $(".menu").scrollTop(0);
          $("body").removeClass("fixed");
          $("span[id*='DivCourseSwitcher']").removeClass("hidden");
          $("#OpenCourseMaterial").removeClass("hidden");
        }
      } else {
        if (!$(".menu").hasClass("selected")) {
          $(".menu").toggleClass("selected");
          $(".menu").trigger("stateChanged");
          $("#OpenCourseMaterial").addClass("hidden");
          $("span[id*='DivCourseSwitcher']").removeClass("hidden");
          eduutils.SetCourseMenuState();
        }
      }
    }

    function SetMenu(mq) {
      var menuState = "open";

      if (luvit.getItem("luvit_coursemenustate")) {
        if (luvit.getItem("luvit_coursemenustate").indexOf("main") > -1) {
          menuState = $.parseJSON(luvit.getItem("luvit_coursemenustate")).main;
        }
      }

      if (menuState === "closed") {
        toggleMenuAuto("close");
      } else {
        //Set state of menu
        toggleMenuAuto("open");
        $(
          ".doc-actions, .content-edu, .header-wrapper, .course-switcher",
        ).addClass("pushed");
        if (luvit.getItem("luvit_coursemenustate")) {
          if (
            $.parseJSON(luvit.getItem("luvit_coursemenustate")).main == "open"
          ) {
          } else {
            if (luvit.getItem("luvit_coursemenustate").indexOf("main") == -1) {
              $(".course.menu").addClass("selected");
            } else {
              if (
                $.parseJSON(luvit.getItem("luvit_coursemenustate")).main ==
                "open"
              ) {
                $(".course.menu").addClass("selected");
              } else {
                $(".course.menu").removeClass("selected");
              }
            }
          }
        } else {
          $(".course.menu").addClass("selected");
        }
      }
    }

    /* function SetActiveCourseMenuItem(item) {

        $(".course.menu .menu-expandlist-item, .course.menu .menu-expandlist-header").removeClass("active");
        if ($(item).hasClass("menu-expandlist-item") || $(item).hasClass("menu-expandlist-header")) {
            $(item).addClass("active");
        } else {
            $(item).parent().addClass("active");
        }
        var state;
        var menuId;

        if ($(item).data("id")) {
            state = { active: $(item).data("id") };
            menuId = (item).data("id");
        }
        else {
            state = { active: $(item).parent().data("id") };
            menuId = $(item).parent().data("id");
        }

        if (luvit.getItem("luvit_coursemenustate")) {
            var menuState = $.parseJSON(luvit.getItem("luvit_coursemenustate"));
            menuState.active = menuId;
            luvit.setItem("luvit_coursemenustate", JSON.stringify(menuState));
        }
        else
            luvit.setItem("luvit_coursemenustate", JSON.stringify(state));

    }*/

    /* function CloseCourseSubMenus() {

        $(".course.menu .menu-expandlist-content").not("#mycourseslist").hide();

        $.each($(".course.menu .menu-expandlist-content").not("#mycourseslist").prev(".menu-expandlist-header"), function (index, value) {
            $(value).find("[class*='menu-icon-']").addClass("menu-icon-expand").removeClass("menu-icon-collapse");
        });
    }*/

    function RemovePush(mqPushed) {
      if (mqPushed.matches) {
        $(".doc-actions, .content-edu, .header-wrapper").removeClass(
          "moveleft",
        );
        $(
          ".doc-actions, .content-edu, .header-wrapper, .course-switcher",
        ).removeClass("pushed");
      }
    }
    function MoveLeft(mqMoveLeft) {
      if (mqMoveLeft.matches) {
        if (!$(".course.menu").hasClass("selected"))
          $(".doc-actions, .content-edu, .header-wrapper").addClass("moveleft");
      }
    }

    eduutils.SetCourseMenuState();

    if (matchMedia) {
      if (luvit.mqMobile.matches) {
        toggleMenuAuto("close");
      } else {
        var mqClose = window.matchMedia("(max-width: 1025px)");
        mqClose.addListener(SetMenu);
        SetMenu(mqClose);
      }
    }
  });
});
